import { MessagingConversation, MessagingMessage, MessagingUser } from '@/types/shared/messaging';

export const mockMessagingUsers: MessagingUser[] = [
  {
    id: '1',
    firstName: 'John',
    lastName: 'Resident',
    unitNumber: 'A-101',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=JohnResident',
    role: 'resident',
    isOnline: true,
  },
  {
    id: '2',
    firstName: 'Maria',
    lastName: 'Garcia',
    unitNumber: 'B-205',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Maria',
    role: 'resident',
    isOnline: true,
  },
  {
    id: '3',
    firstName: 'David',
    lastName: 'Chen',
    unitNumber: 'C-102',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=David',
    role: 'resident',
    isOnline: false,
    lastSeen: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: '4',
    firstName: 'Emma',
    lastName: 'Wilson',
    unitNumber: 'A-205',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    role: 'resident',
    isOnline: true,
  },
  {
    id: '5',
    firstName: 'Lisa',
    lastName: 'Garcia',
    unitNumber: 'E-101',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lisa',
    role: 'property_manager',
    isOnline: true,
  },
];

export const mockChatMessages: MessagingMessage[] = [
  {
    id: 'msg1',
    content: "Hey everyone! Who's interested in organizing a community BBQ this weekend?",
    senderId: '2',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:00:00Z',
    type: 'text',
    isRead: true,
  },
  {
    id: 'msg2',
    content: '@Sarah Johnson That sounds great! I can help with setup.',
    senderId: '3',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:05:00Z',
    type: 'text',
    isRead: true,
    replyTo: 'msg1',
  },
  {
    id: 'msg3',
    content: 'Count me in! Should we do it at the community center?',
    senderId: '4',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:10:00Z',
    type: 'text',
    isRead: true,
  },
  {
    id: 'msg4',
    content: '@Emma Wilson Perfect! I can reserve the grills.',
    senderId: '5',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:15:00Z',
    type: 'text',
    isRead: true,
    replyTo: 'msg3',
  },
  {
    id: 'msg5',
    content: "I'll coordinate with the caterers if anyone wants professional help with food.",
    senderId: '5',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:20:00Z',
    type: 'text',
    isRead: true,
  },
  {
    id: 'msg6',
    content: 'What time should we start? I was thinking around 2 PM?',
    senderId: '2',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:25:00Z',
    type: 'text',
    isRead: true,
  },
  {
    id: 'msg7',
    content: '@Maria Garcia That works for me! Should we also set up some games for the kids?',
    senderId: '3',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:30:00Z',
    type: 'text',
    isRead: true,
    replyTo: 'msg6',
  },
  {
    id: 'msg8',
    content: 'Great idea! I have some outdoor games we can borrow.',
    senderId: '2',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:35:00Z',
    type: 'text',
    isRead: true,
  },
  {
    id: 'msg9',
    content: '@Lisa Garcia Absolutely! Professional catering would be fantastic.',
    senderId: '4',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:40:00Z',
    type: 'text',
    isRead: true,
    replyTo: 'msg5',
  },
  {
    id: 'msg10',
    content: 'I can bring some folding tables and chairs if needed.',
    senderId: '1',
    conversationId: 'conv-community-bbq',
    timestamp: '2024-01-15T10:45:00Z',
    type: 'text',
    isRead: true,
  },
];

export const mockMessagingConversations: MessagingConversation[] = [
  {
    id: 'conv-community-bbq',
    type: 'group',
    name: 'Community BBQ Planning',
    participants: [
      mockMessagingUsers[0],
      mockMessagingUsers[1],
      mockMessagingUsers[2],
      mockMessagingUsers[3],
      mockMessagingUsers[4],
    ],
    lastMessage: mockChatMessages[mockChatMessages.length - 1],
    unreadCount: 2,
    isPinned: true,
    isArchived: false,
    groupAvatar: '/group-chat-avatar.svg',
  },
  {
    id: 'conv-direct-property-manager',
    type: 'direct',
    participants: [mockMessagingUsers[0], mockMessagingUsers[4]],
    lastMessage: {
      id: 'msg11',
      content: 'Hi John, your maintenance visit is scheduled for tomorrow at 10am.',
      senderId: '5',
      conversationId: 'conv-direct-property-manager',
      timestamp: '2024-01-18T14:30:00Z',
      type: 'text',
      isRead: false,
    },
    unreadCount: 1,
    isPinned: false,
    isArchived: false,
  },
  {
    id: 'conv-community-updates',
    type: 'group',
    name: 'Glastonbury Updates',
    participants: [mockMessagingUsers[0], mockMessagingUsers[1], mockMessagingUsers[2]],
    lastMessage: {
      id: 'msg12',
      content: 'Reminder: Community meeting this Thursday at 7pm in the clubhouse.',
      senderId: '2',
      conversationId: 'conv-community-updates',
      timestamp: '2024-01-17T09:00:00Z',
      type: 'text',
      isRead: true,
    },
    unreadCount: 0,
    isPinned: false,
    isArchived: false,
    groupAvatar: '/group-chat-avatar.svg',
  },
];
